import React from "react";
import { Footer } from "./components/Footer";
import Header from "./components/Header";
import Banner from "./images/esg-banner.jpg";
import Service01 from "./images/esg01.jpg";
import Service02 from "./images/esg02.jpg";
import Service03 from "./images/esg03.jpg";
import Slider from "react-slick";
import cardimg1 from "./images/ico1.png";
import cardimg2 from "./images/ico2.png";
import cardimg3 from "./images/ico3.png";
import cardimg4 from "./images/ico4.png";
import cardimg5 from "./images/ico5.png";
import prodcell1 from "./images/cell1.png";
import prodcell2 from "./images/cell2.png"; 
import { Helmet } from "react-helmet";
import pdf1 from "./PDF/Sheet-PiranhaP-Type.pdf"; 
import pdf2 from "./PDF/PE_Blue_Shark_N-TYPE_TC_V00_G12R_US.pdf"; 
import banner from "./images/WEB.mp4"; 

export const Demo_Page = () => {

  return (
    <>
      <Helmet>
        <title>Commitment to Build Sustainable Future | Premier Energies</title>
        <meta
          name="description"
          content="Premier Energies is committed to build a sustainable future through high-quality products and energy-efficient solar solutions."
        />
        <link
          rel="canonical"
          href="https://premierenergies.com/sustainbility"
        />
        <meta
          property="og:url"
          content="https://premierenergies.com/sustainbility"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Commitment to Build Sustainable Future | Premier Energies"
        />
        <meta
          name="og:description"
          content="Premier Energies is committed to build a sustainable future through high-quality products and energy-efficient solar solutions."
        ></meta>

      </Helmet>
      <Header />
      {/* <section id="banner" className="p-0 ">
        <div className="banner">
          <img src={Banner} alt="img" />
          <div className="container">
            <div className="homcolft position-absolute position-right ">
              <span className="colorborder">
                <em></em>
              </span>
              <h2
                data-aos="fade-down"
                data-aos-offset="100"
                data-aos-easing="ease-in-sine"
                data-aos-once="true"
                data-aos-duration="500"
              >
                ILLUMINATING THE FUTURE,<br />
                ONE CELL AT A TIME
              </h2>
            </div>
          </div>
        </div>
      </section> */}
      <section id="banner" className="p-0">
  <div className="banner">
    {/*<video autoPlay loop muted playsInline className="w-100">
      <source src={banner} type="video/mp4" />
      Your browser does not support the video tag.
    </video>*/}

  {/*  <video
  autoPlay
  loop
  muted
  playsInline
  className="w-100"
  preload="auto"
  controls={false}
>
  <source src={banner} type="video/mp4" />
  Your browser does not support the video tag.
</video>
*/}
<video
  autoPlay
  loop
  muted
  playsInline
  className="w-100"
  preload="auto"
  height="100%"
  style={{ width: '100%' }}
  controls={false}
>
  <source src={banner} type="video/mp4" />
  Your browser does not support the video tag.
</video>


    <div className="container">
      {/* <div className="homcolft position-absolute position-right">
        <span className="colorborder">
          <em></em>
        </span>
        <h2
          data-aos="fade-down"
          data-aos-offset="100"
          data-aos-easing="ease-in-sine"
          data-aos-once="true"
          data-aos-duration="500"
        >
          ILLUMINATING THE FUTURE,<br />
          ONE CELL AT A TIME
        </h2>
      </div> */}
    </div>
  </div>
</section>
      <section id="Solar" className="sollar-demo pb-3">
        <div className="infrastructure">
          <div className="largecircleleft"></div>
          <div className="midcircleright"></div>
          <div className="smallcirclerightdark"></div>
 <div className="container">
            <div className="row">
              <div className="web-container">
                <div className="title centerheading">
                  <div className="centerit">
                    <span className="colorborder">
                      <em></em>
                    </span>
                    <h2
                      data-aos="fade-down"
                      data-aos-offset="100"
                      data-aos-easing="ease-in-sine"
                      data-aos-once="true"
                      data-aos-duration="500"
                    >
                     SOLAR CELL
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container pt-lg-5 pt-1">
            {/* MONO PERC Bifacial Cell */}
            <div className="web-container">
              <div className="row align-items-center mb-5">
                <div className="col-12">
                  <div className="infotitle mb-3">
                    <h3>
                      MONO PERC Cell
                    </h3>
                    <h2> MONO PERC Bifacial Cell
                    </h2>

                  </div>
                </div>
                  <div className="col-md-5 text-center d-lg-none d-block">
                  <img
                    src={prodcell1}
                    alt="Mono PERC Cell"
                    className="img-fluid"
                 
                  />
                </div>
                <div className="col-md-7">

                  <div className="col-md-12 infracont mb-2">
                    <div className="preinfo" >
                      <h3 className="fw-bold"> India's 1st Mono PERC Bi-facial Solar Cell in the format 182mm x 182mm</h3>
                    </div>
                  </div>


                  <span className="fw-bold h5 py-3   text-start text-uppercase">Monocrystalline P-Type Bifacial Cell</span>
                  <ul className="list-unstyled updated-list mt-2">
                    <li>


                      <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg1} class=" mt-2 mt-2" alt="Card image" />
                          </div>
                          <div className="col-md-11 col-10">
                            <div className="card-body p-0">
                              <span className="card-title">High Conversion Efficiency</span>
                              <p className="card-text">Our solar cells enhance efficiency through superior rear surface reflection, maximizing photovoltaic conversion and energy utilization. With an average efficiency of 23.7% and a bifaciality factor of 75%, they deliver exceptional performance.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg2} class=" mt-2 mt-2" alt="Card image"   />
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title"> Low Degradation Rate</span>
                              <p className="card-text">Our cells maintain stable efficiency across diverse lighting conditions, ensuring prolonged lifespan and consistent energy output.</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      
                    </li>
                    <li>
                       <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg3} class=" mt-2 mt-2" alt="Card image" />
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title"> Temperature Resilience</span>
                              <p className="card-text">Engineered for high temperatures, our cells maintain efficiency even in harsh environments, making them ideal for regions with intense sunlight or hot climates. With a Power Temperature Coefficient as low as -0.32%/°C, they ensure consistent performance in extreme conditions.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                       
                    </li>
                    <li>
                       <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg4} class=" mt-2 mt-2" alt="Card image" />
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title"> Anti-PID (Potential Induced Degradation)</span>
                              <p className="card-text">Our technology minimizes efficiency losses caused by electrolyte impurities, ensuring reliable performance in demanding conditions. With exceptional Anti-PID performance, we achieve PID degradation as low as 0.5%.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                     
                    </li>
                    <li>
                       <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg5} class=" mt-2 mt-2" alt="Card image" />
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title">Low Light-induced Degradation</span>
                              <p className="card-text">Relative conversion efficiency of 97% under 200w/m2 low-light conditions.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                    </li>
                  </ul>
                </div>
                <div className="col-md-5 text-center d-lg-block d-none">
                  <img
                    src={prodcell1}
                    alt="Mono PERC Cell"
                    className="img-fluid"
                 
                  />
                </div>
              </div>

              <hr className="my-5" style={{ borderTop: "3px solid #1a5399" }} />
<div class="largecircleright"></div>

               <div className="row align-items-center mb-5">
                
                <div className="col-12">
                  <div className="infotitle mb-3">
                    <h3>
                      Topcon Cell
                    </h3>
                    <h2> G12R Bifacial Cell
                    </h2>

                  </div>
                </div>
              
                <div className="col-md-5 text-center">
                  <img
                    src={prodcell2}
                    alt="Mono PERC Cell"
                    className="img-fluid"
                 
                  />
                </div>

                  <div className="col-md-7">

                  <div className="col-md-12 infracont mb-md-3 mb-0" >
                    <div className="preinfo mb-md-3 mb-0" style={{ borderBottom: '0px solid #000' }}>
                      <h3 className="fw-bold mb-0"  > G12R Monocrystalline Bifacial Topcon Cell <br/>(182.2mm x 210mm)</h3>
                    </div>
                  </div>

 <span className="">&nbsp;</span>
                  
                  <ul className="list-unstyled updated-list  solar-list-2">
                    <li>


                      <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg1} class=" mt-2 mt-2" alt="Card image" />
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title">High Conversion Efficiency:</span>
                              <p className="card-text">Our solar cells enhance efficiency through superior rear surface reflection, maximizing photovoltaic conversion and energy utilization. With an average efficiency of 23.7% and a bifaciality factor of 85%, they offer exceptional performance and energy output.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg2} class=" mt-2 mt-2" alt="Card image"/>
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title"> Low Degradation Rate</span>
                              <p className="card-text">Our cells maintain stable efficiency across diverse lighting conditions, ensuring prolonged lifespan and consistent energy output.</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      
                    </li>
                    <li>
                       <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg3} class=" mt-2 mt-2" alt="Card image" />
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title">Temperature Resilience</span>
                              <p className="card-text">Engineered for high temperatures, our cells maintain efficiency in even harsh environments, making them ideal for regions with intense sunlight or hot climates. With a Power Temperature Coefficient as low as -0.30%/°C, they ensure consistent performance in extreme conditions.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                       
                    </li>
                    <li>
                       <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg4} class=" mt-2 mt-2" alt="Card image"/>
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title">Anti-PID (Potential Induced Degradation)</span>
                              <p className="card-text">Our technology minimizes efficiency losses caused by electrolyte impurities, ensuring reliable performance in demanding conditions. With exceptional Anti-PID performance, we achieve PID degradation as low as 0.5%.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                     
                    </li>
                    <li>
                       <div className="feature-card"  >
                        <div className="row g-0">
                          <div className="col-md-1 col-2 text-end">
                            <img src={cardimg5} class=" mt-2 mt-2" alt="Card image"/>
                          </div>
                          <div className="col-md-11  col-10">
                            <div className="card-body p-0">
                              <span className="card-title">Low Light-induced Degradation</span>
                              <p className="card-text">Relative conversion efficiency of 97% under 200w/m2 low-light conditions.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                    </li>
                  </ul>
                </div>
              </div>

              {/* TOPCON G12R Bifacial Cell */}
              {/* <div className="row align-items-center">
                <div className="col-md-7 order-md-2">
                  <h6 className="text-uppercase fw-bold text-secondary">Topcon Cell</h6>
                  <h2 className="fw-bold" style={{ color: "#2b2b2b" }}>
                    G12R <span style={{ color: "#2b7a77" }}>Bifacial Cell</span>
                  </h2>
                  <p className="fw-bold">G12R Monocrystalline Bifacial Topcon Cell (182.2mm x 210mm)</p>
                  <ul className="list-unstyled">
                    <li>
                      <strong>High Conversion Efficiency:</strong> Our solar cells enhance efficiency through superior rear surface reflection, maximizing photovoltaic conversion and energy utilization. With an average efficiency of 24.5% and a bifaciality factor of 85%, they offer exceptional performance and energy output.
                    </li>
                    <li>
                      <strong>Low Degradation Rate:</strong> Our cells maintain stable efficiency across diverse lighting conditions, ensuring prolonged lifespan and consistent energy output.
                    </li>
                    <li>
                      <strong>Temperature Resilience:</strong> Engineered for high temperatures, our cells maintain efficiency in even harsh environments, making them ideal for regions with intense sunlight or hot climates. With a Power Temperature Coefficient as low as -0.30%/°C, they ensure consistent performance in extreme conditions.
                    </li>
                    <li>
                      <strong>Anti-PID (Potential Induced Degradation):</strong> Our technology minimizes efficiency losses caused by electrolyte impurities, ensuring reliable performance in demanding conditions. With exceptional Anti-PID performance, we achieve PID degradation as low as 0.5%.
                    </li>
                    <li>
                      <strong>Low Light-induced Degradation:</strong> Relative conversion efficiency of 97% under 200w/m2 low-light conditions.
                    </li>
                  </ul>
                </div>
                <div className="col-md-5 order-md-1 text-center">
                  <img
                    src={prodcell2}
                    alt="G12R Cell"
                    className="img-fluid"
                     
                  />
                </div>
              </div> */}

              <div className="row">
                              <div className="downloadsheet">
                                <h4 class="subhead">Download Data Sheet</h4>
                                <div className="warranty downloads">
                                  <ul>
                                    
                                      <>
                                        <li>
                                          <a
                                            href={pdf1}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                           
                                          > MONO PERC Bifacial Cell</a>
                                        </li><li>
                                          <a
                                            href={pdf2}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                           
                                          >G12R <br/> Bifacial Cell</a>
                                        </li>
                                      </>
                                    
                                  </ul>
                                </div>
                              </div>
                            </div>
            </div>
          </div>

        </div>


      </section>




      <Footer />
    </>
  );
};